import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartPlus,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import {
  faTrashAlt,
} from "@fortawesome/free-regular-svg-icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import "./style.scss";
import {
  useGetWishlistQuery,
  useAddToCartMutation,
  useRemoveFromWishlistMutation,
  useAddToWishlistMutation,
} from "../../../services/AddToCartAPI";
import { Link } from "react-router-dom";
import Loader from "../fullPageLoader"
import { useGetColorThemeQuery } from '../../../services/commonAPI';
import QuickView from "../quick-view-product"

function Index() {
  const { data, error, isLoading, isSuccess, refetch } = useGetWishlistQuery();
  const [showAddToCartMessage, seShowAddToCartMessage] = useState(false);
  const [isWishlisted, setIsWishlisted] = useState({});
  const [addToCart] = useAddToCartMutation();
  const [showWishListMessage, seShowWishListMessage] = useState(false);
  const [addToWishlist] = useAddToWishlistMutation(); // Add to Wishlist mutation
  const [removeFromWishlist] = useRemoveFromWishlistMutation();
  const [isOpenQuickViewModal, setHandleShowQuickViewModal] = useState(false);
  const [quickViewId, setQuickViewId] = useState("")

  const {
    data: colorthemeData,
  } = useGetColorThemeQuery();

  useEffect(() => {
    refetch();
  }, [refetch]);

  console.log("addToWishlist", addToWishlist);
  console.log("isWishlisted", isWishlisted);
  const handleAddToCart = async (productId) => {
    const accessToken = localStorage.getItem("access_token");
    // const cartToken = localStorage.getItem("cartToken");

    const payload = {
      product_id: productId,
      quantity: 1, // Default quantity is 1
    };

    // Add user_id only if the user is logged in
    if (accessToken) {
      payload.user_id = localStorage.getItem("gridMarker");
    }

    try {
      const response = await addToCart(payload).unwrap();

      // If the user is a guest and a cart token is returned, store it in localStorage
      if (!accessToken && response.guest_cart_token) {
        localStorage.setItem("cartToken", response.guest_cart_token);
      }
      if (response) {
        seShowAddToCartMessage(response.message);
      }
    } catch (err) {
      seShowAddToCartMessage(err?.data?.message);
    }
  };

  const handleCloseAddCartToast = () => {
    seShowAddToCartMessage(false);
  };

  const handleWishlistToggle = async (e, productId) => {
    e.preventDefault(); // Prevent link navigation
    const accessToken = localStorage.getItem("access_token");

    const payload = {
      product_id: productId,
      // user_id: accessToken ? localStorage.getItem("gridMarker") : null,
    };

    if (accessToken) {
      payload.user_id = localStorage.getItem("gridMarker");
    }

    try {
      const response = await removeFromWishlist(payload).unwrap();
      setIsWishlisted((prev) => ({ ...prev, [productId]: false }));
      seShowWishListMessage(response.message);
      refetch();
    } catch (err) {
      console.error("Failed to update wishlist:", err);
      seShowWishListMessage(err?.data?.message);
    }
  };

  const handleCloseWishListToast = () => {
    seShowWishListMessage(false);
  };
  const handleShowQuickView = (id) => {
    setHandleShowQuickViewModal(true)
    setQuickViewId(id)
  }
  const handlecloseQuikViewMOdal = () => {
    setHandleShowQuickViewModal(false)
  }

  if (isLoading) return <Loader />;
  if (error) return <p>Failed to load Data.</p>;

  return (
    <div className="container">
      <div className="wishlist-page">
        {showAddToCartMessage && (
          <div className="row mb-4 justify-content-center">
            <div className="col-md-6 col-sm-12 -col-lg-6">
              <div className="d-flex toast-message-add-to-cart">
                <p>{showAddToCartMessage}</p>
                {isSuccess && (
                  <Link to="/cart-page">
                    <p className="primary-button-link">View Cart Page</p>
                  </Link>
                )}
                <FontAwesomeIcon
                  icon={faClose}
                  onClick={handleCloseAddCartToast}
                  className="toast-close"
                />
              </div>
            </div>
          </div>
        )}

        {showWishListMessage && (
          <div className="row mb-4 justify-content-center">
            <div className="col-md-6 col-sm-12 -col-lg-6">
              <div className="d-flex toast-message-add-to-cart">
                <p>{showWishListMessage}</p>

                <FontAwesomeIcon
                  icon={faClose}
                  onClick={handleCloseWishListToast}
                  className="toast-close"
                />
              </div>
            </div>
          </div>
        )}

        <div className="row">
          {data?.data?.length > 0 ? (
            data?.data?.map((product) => (
              <div className="col-md-4 col-sm-12 col-lg-4" key={product?.id}>
                <div className="wishlist-card">
                  <p
                    className="text-end fa-delete"
                    onClick={(e) =>
                      handleWishlistToggle(e, product?.product?.id)
                    }
                  >
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </p>
                  {product?.product?.is_new === 1 && (
                    <div className="new-tag">New</div>
                  )}
                  {product?.product?.discount_details?.discount_percentage > 0 && (
                    <div className="discount-tag" style={{ backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" }}>
                      {Math.round(product?.product?.discount_details?.discount_percentage)}%
                    </div>
                  )}
                  {product?.product?.is_hot === 1 && (
                    <div className="hot-tag">hot</div>
                  )}
                  <div className="wish-list-product-img">
                    <img
                      src={product?.product?.product_main_image_url_large}
                      alt="wishlist-img"
                      className="img-fluid"
                    />
                  </div>

                  <div className="product-details">
                    <p className="product-name">
                      {product?.product?.product_name}
                    </p>
                    {/* <p className="product-category">
                      {product?.product?.category?.category_name}
                    </p> */}
                    <p className="product-rate" style={{ color: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" }}>
                      ${product?.product?.selling_price}
                    </p>
                  </div>

                  <div className="hover-actions">
                    <p
                      title="Add to Cart"
                      onClick={(e) => {
                        e.preventDefault(); // Prevent link navigation
                        handleAddToCart(product?.product.id);
                      }}
                    >
                      <FontAwesomeIcon icon={faCartPlus} />
                    </p>

                    <Link
                      onClick={() => handleShowQuickView(product?.product.id)}
                      title="View Details"
                    >
                      <p><FontAwesomeIcon icon={faEye} /></p>
                    </Link>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center w-100">
              <h4>There are no products on the Wishlist!</h4>
            </div>
          )}
        </div>
      </div>
      {isOpenQuickViewModal && <QuickView isOpenQuickViewModal={isOpenQuickViewModal} handlecloseQuikViewMOdal={handlecloseQuikViewMOdal} quickViewId={quickViewId} />}
    </div>
  );
}

export default Index;
